import React from 'react';

import { getPlatformLogoSrc } from '../constants/branding';

export type ProjectGateHeaderProps = {
  actions?: React.ReactNode;
};

/**
 * Post-login project gate header — same 48px EMS top bar as the client shell,
 * with a readable platform logo (no sidebar menu on this screen).
 */
export function ProjectGateHeader({ actions }: ProjectGateHeaderProps) {
  const basename = process.env.PUBLIC_URL || '';

  return (
    <header className="app-topbar ps-gate__topbar">
      <div className="app-topbar__start">
        <a
          className="ps-gate__brand"
          href={basename || '/'}
          aria-label="Traxccel home"
        >
          <img src={getPlatformLogoSrc('big', basename)} alt="Traxccel Logo" />
        </a>
      </div>
      {actions ? <div className="app-topbar__actions">{actions}</div> : null}
    </header>
  );
}

export default ProjectGateHeader;
